import classNames from '@/utils/classNames';
import type { ComponentProps } from 'react';
import type { FCC } from 'react-fc';

interface IProps extends ComponentProps<'div'> {
    $preformatted?: boolean;
    limit?: boolean;
}

export const Prose: FCC<IProps> = ({ className, children, limit, $preformatted, ...rest }) => {
    return (
        <div
            className={classNames(className, 'cds-prose', {
                'cds-prose--preformatted': $preformatted,
                'cds-prose--limit-line': limit,
            })}
            {...rest}
        >
            {children}
        </div>
    );
};
